export default __webpack_public_path__ + "static/exp3-a9f99b226241c0598e75f1e7ed27a245.webp";